module.exports = __webpack_public_path__ + "img/fur-white.ab599a34.svg";